'use client';

import { useModalContext } from '~/context/flp/ModalContext/ModalContext';
import useToggleAccountModal from '~/hooks/common/accountModal/useToggleAccountModal';
import useSetDataDogContext from '~/hooks/flp/telemetry/useSetDataDogContext';

export default function FinancingData() {
  const { isAccountModalOpen, setAccountModalOpen } = useModalContext();

  useToggleAccountModal({ isAccountModalOpen, setAccountModalOpen });
  useSetDataDogContext();

  return null;
}
